module.exports = __webpack_public_path__ + "fonts/Andada-Regular.c6ba404ccfea0e5079deb909ed10d6f8.ttf";